var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _vm.isSelectRoles
      ? _c("div", { staticClass: "login-form" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("p", { staticClass: "login-title" }, [
            _vm._v(_vm._s(_vm.$t("login.welcome"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "role-step" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    size: "medium",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("login.selectRole") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("login.selectRolePlaceholder"),
                          },
                          model: {
                            value: _vm.role,
                            callback: function ($$v) {
                              _vm.role = $$v
                            },
                            expression: "role",
                          },
                        },
                        _vm._l(_vm.roleList, function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: {
                              label: _vm.getRoleName(item),
                              value: item,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "role-back-button",
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.backToLogin($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("login.backToLogin")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "role-login-button",
                  attrs: { type: "primary" },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changeRole($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("login.enterSystem")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ])
      : _c("div", { staticClass: "login-loading" }, [
          _c("i", { staticClass: "el-icon-loading" }),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-banner" }, [
      _c("img", {
        attrs: { src: require("@/assets/login/logo.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }